import * as React from "react";
const SvgButtonInvitation = (props) => /* @__PURE__ */ React.createElement("svg", {
	id: "Multiple-Actions-Add--Streamline-Streamline-3.0",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	height: 24,
	width: 24,
	...props
}, /* @__PURE__ */ React.createElement("desc", null, "\n		Multiple Actions Add Streamline Icon: https://streamlinehq.com\n	"), /* @__PURE__ */ React.createElement("defs", null), /* @__PURE__ */ React.createElement("title", null, "multiple-actions-add"), /* @__PURE__ */ React.createElement("path", {
	d: "M11.25 17.25a6 6 0 1 0 12 0 6 6 0 1 0 -12 0",
	fill: "none",
	stroke: "#000000",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 1.5
}), /* @__PURE__ */ React.createElement("path", {
	d: "m17.25 14.25 0 6",
	fill: "none",
	stroke: "#000000",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 1.5
}), /* @__PURE__ */ React.createElement("path", {
	d: "m14.25 17.25 6 0",
	fill: "none",
	stroke: "#000000",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 1.5
}), /* @__PURE__ */ React.createElement("path", {
	d: "M10.782 10.513A6.052 6.052 0 0 0 6.75 9a6 6 0 0 0 -6 5.25",
	fill: "none",
	stroke: "#000000",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 1.5
}), /* @__PURE__ */ React.createElement("path", {
	d: "M3.375 4.125a3.375 3.375 0 1 0 6.75 0 3.375 3.375 0 1 0 -6.75 0",
	fill: "none",
	stroke: "#000000",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 1.5
}), /* @__PURE__ */ React.createElement("path", {
	d: "M13.875 3.375a2.625 2.625 0 1 0 5.25 0 2.625 2.625 0 1 0 -5.25 0",
	fill: "none",
	stroke: "#000000",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 1.5
}), /* @__PURE__ */ React.createElement("path", {
	d: "M20.4 9a4.5 4.5 0 0 0 -7.285 -0.71",
	fill: "none",
	stroke: "#000000",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 1.5
}));
export { SvgButtonInvitation as ReactComponent };
